export const DEFAULT_SCENE = 'administration:queues';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

export const ADD_QUEUE_BUTTON_TAG = `${DEFAULT_SCENE}:button-add`;
export const SAVE_QUEUE_BUTTON_TAG = `${DEFAULT_SCENE}:button-save`;
export const ASSIGN_QUEUE_BUTTON_TAG = `${DEFAULT_SCENE}:button-assign`;
export const ADD_CUSTOM_QUEUE_TAG_BUTTON_TAG = `${DEFAULT_SCENE}:button-add-custom-queue-tag`;

export const getFieldsInputTag = (fieldName: string) => `${DEFAULT_SCENE}:input-${fieldName}`;

// QueuesList
const LIST_OF_QUEUES = `${DEFAULT_SCENE}:list-of-queues`;
export const LIST_OF_QUEUES_CONTAINER_TAG = `${LIST_OF_QUEUES}:container`;
export const getQueuePropTag = (propName: string) => `${LIST_OF_QUEUES}:queue-${propName}`;

// SearchQueues
const SEARCH_QUEUES = `${DEFAULT_SCENE}:filter-queues`;
export const SEARCH_QUEUES_CONTAINER_TAG = `${SEARCH_QUEUES}:container`;

export const getSearchFieldsInputTag = (fieldName: string) => `${SEARCH_QUEUES}:input-${fieldName}`;

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;

export const ASSIGN_QUEUE_CONTAINER_TAG = `${DEFAULT_SCENE}:bulk-assign:container`;
export const ASSIGN_QUEUE_HEADING_TAG = `${DEFAULT_SCENE}:bulk-assign:heading`;
export const ASSIGN_QUEUE_FILTER_BOX_TAG = `${DEFAULT_SCENE}:bulk-assign:filter-box`;
